import { useEffect, useRef, useState } from "react"
import { Formik, Field, Form } from "formik"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    Wrapper,
    ActionSection,
    ScrollableContent,
    SideCancelBtn,
    RupeeIcon,
    ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCheckCircle, FaRegCalendar, FaMoneyBillWave } from "react-icons/fa";
import { paymentModes } from "../../helpers"

const MarkAsPaidStaffCommission = ({
    handleClose,
    selectedStaff,
    payCommissionMutate,
    payCommissionLoading,
}) => {
    const formikRef = useRef(null)
    const [calendarOpen, setCalendarOpen] = useState(false);
    const paymentTypes = [
        {
            label: "Full Payment",
            value: 0,
            icon: <FaCheckCircle className="w-6 h-6 text-green-500" />,
        },
        {
            label: "Partial Payment",
            value: 1,
            icon: <FaMoneyBillWave className="w-6 h-6 text-blue-500" />,
        },
    ];

    const defaultPaidDate = selectedStaff?.paidDate
        ? moment(selectedStaff.paidDate).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initialValues = {
        amount: selectedStaff.balance,
        paidDate: defaultPaidDate,
        paymentMode: 0,
        paymentType: 0,
        id: selectedStaff?.id,
    }

    const handlePaymentModeChange = (value) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentMode", value)
        }
    }

    const handleSubmit = (values) => {
        const amountRegex = /^(?!0+$)\d{1,7}$/
        const maxAmount = 5000000

        if (!amountRegex.test(values.amount) || Number.parseInt(values.amount) > maxAmount) {
            toast.error("Commission amount must be between 1 and 50,00,000 and contain only numbers")
            return
        }
        if (values.paymentType === 1) {
            if (Number(values.amount) > Number(selectedStaff.balance)) {
                toast.error(`Amount cannot exceed available balance of ₹${selectedStaff.balance}`)
                return
            }
        }

        if (!values.paidDate) {
            toast.error("Paid date is required")
            return
        }

        if (!values.paymentMode) {
            toast.error("Payment mode is required")
            return
        }

        payCommissionMutate({
            id: selectedStaff?.id,
            amount: values.amount,
            paidDate: values.paidDate,
            mode: values.paymentMode,
            isPartialPayment: values.paymentType,
        })
    }

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Mark Commission as Paid</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, setFieldValue, handleChange, resetForm }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    {/* {!hidePaymentType && ( */}
                                    <InputGroup>
                                        <Label htmlFor="paymentType">Payment Type *</Label>
                                        <div className="grid grid-cols-3 gap-2">
                                            {paymentTypes.map((option) => (
                                                <OptionCard
                                                    key={option.value}
                                                    type="button"
                                                    isselected={(values.paymentType === option.value).toString()}
                                                    onClick={() => {
                                                        setFieldValue("paymentType", option.value);
                                                        if (option.value === 0) {
                                                            setFieldValue("amount", selectedStaff.balance);
                                                        } else {
                                                            setFieldValue("amount", "");
                                                        }
                                                    }}
                                                >
                                                    <span className="text-sm">{option.label}</span>
                                                </OptionCard>
                                            ))}
                                        </div>
                                    </InputGroup>
                                    {/* )} */}
                                    <InputGroup>
                                        <Label htmlFor="amountPaid">
                                            {values.paymentType === 0 ? "Amount" : "Partial Amount"} *
                                        </Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="text"
                                                name="amount"
                                                id="amount"
                                                className={`w-full truncate pl-5`}
                                                //value={userValues.balance}
                                                disabled={values.paymentType === 0}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="paidDate">Paid Date *</Label>
                                        <FieldWrappers className="relative">
                                            <DatePicker
                                                //selected={values.paidDate ? new Date(values.paidDate) : new Date()}
                                                selected={values.paidDate ? moment(values.paidDate, "YYYY-MM-DD").toDate() : new Date()}
                                                onChange={(date) => {
                                                    const formattedDate = moment(date).format("YYYY-MM-DD");
                                                    handleChange({
                                                        target: {
                                                            name: "paidDate",
                                                            value: formattedDate,
                                                        },
                                                    });
                                                    setCalendarOpen(false);
                                                }}
                                                onClickOutside={() => setCalendarOpen(false)}
                                                onSelect={() => setCalendarOpen(false)}
                                                open={calendarOpen}
                                                onInputClick={() => setCalendarOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="w-full truncate cursor-pointer"
                                                placeholderText="YYYY-MM-DD"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                required
                                                name="paidDate"
                                                id="paidDate"
                                                autoComplete="off"
                                                popperPlacement="bottom-start"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Payment Mode *</Label>
                                        <PaymentModeWrapper>
                                            {paymentModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setFieldValue("paymentMode", mode.value)
                                                        handlePaymentModeChange(mode.value)
                                                    }}
                                                    className={`${values.paymentMode === mode.value ? "bg-primary-color text-white" : "bg-gray-100"
                                                        } `}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </PaymentModeWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={payCommissionLoading}>
                                    {payCommissionLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>

                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const OptionCard = tw.button`
  flex flex-col items-center justify-center p-3 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isselected === "true"
            ? "bg-primary-color/10 border-primary-color"
            : "bg-white hover:bg-gray-50"}
`;

export default MarkAsPaidStaffCommission
